import * as React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NoResultCard(props) {
	const { t: gctrad } = useTranslation();
	return (
		<Box {...props} className="d-flex justify-content-center align-items-center w-100 text-gc-dark-blue font-weight-bold m-0 py-5">
			<div>
				<i className="fa-regular fa-face-thinking d-block text-center mb-2" style={{ fontSize: "4rem" }}></i>
				{gctrad('[:myspace] Aucun résultat')}
			</div>
		</Box>
	);
}